<template>
  <div class="main-menu-page">
    <section class="menu-hero">
      <div class="brand-panel">
        <v-img alt="Logo" class="shrink mr-2 app hero-logo" contain :src="logoimage" transition="scale-transition" />
        <div class="hero-copy">
          <span class="thai-title">{{ "ลงทะเบียนเข้าอาคาร" }}</span>
          <span class="english-title">{{ "VISITOR REGISTRATION" }}</span>
          <v-divider class="title-line"></v-divider>
        </div>
      </div>

      <v-sheet class="folded-corner action-panel">
        <v-container>
          <div class="action-content">
            <div>
              <p class="action-eyebrow">ONE BANGKOK</p>
              <div class="welcome-copy">
                <span class="welcome-en">Welcome</span>
                <span class="welcome-th">ยินดีต้อนรับ</span>
              </div>
            </div>

            <v-card elevation="0" class="box white--text text-capitalize primary-action" color="#344054"
              @click="GotoPDPA()" style="line-height:1.1">
              <span> {{ "ลงทะเบียน" }}</span>
              <small> {{ "REGISTER" }}</small>
            </v-card>
          </div>
        </v-container>
      </v-sheet>
    </section>


    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center;">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "MainMenu",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      urlReader: enurl.apiReaderUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      logoimage: "",
      BGimage: require("@/assets/BG-OB.jpg"),

    };
  },
  mounted: function () {
    // this.GetIp();

    if (localStorage.getItem("LogId") != "") {
      localStorage.setItem("LogId", '');
      location.reload();
    }
    this.logoimage = require("@/assets/OneBangkokLogo.png");
    // setInterval(() => {
    //   this.getCurrentDate();
    // }, 1000);
  },

  methods: {


    GetIp() {
      let self = this;

      axios
        .get(`${self.urlReader}General/GetIp`)
        .then(function (response) {

          //  console.log(response.data);
          localStorage.setItem("IP", response.data);

        })
        .catch(function (error) {
          self.MessageAlert = error;
        });
    },
    // getCurrentDate() {
    //   let self = this;
    //   let newDate = new Date();
    //   let date =
    //     newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
    //   let month = newDate.getMonth() + 1;
    //   let year =
    //     newDate.getFullYear() < 2500
    //       ? newDate.getFullYear() + 543
    //       : newDate.getFullYear();
    //   let hours =
    //     newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
    //   let minutes =
    //     newDate.getMinutes() < 10
    //       ? "0" + newDate.getMinutes()
    //       : newDate.getMinutes();
    //   let seconds =
    //     newDate.getSeconds() < 10
    //       ? "0" + newDate.getSeconds()
    //       : newDate.getSeconds();
    //   self.Datetime = `${date}/${
    //     month < 10 ? `0${month}` : `${month}`
    //   }/${year}  ${hours}:${minutes}:${seconds}`;
    // },

    GotoPDPA() {
      let self = this;
      self.$router.push("/PDPAPage");
    },
    GotoScan() {
      let self = this;
      self.$router.push("/ScanQrcode");
    },
  },
};
</script>
<style scoped>
.main-menu-page {
  min-height: 100vh;
}

.menu-hero {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(560px, 0.96fr) minmax(500px, 1.04fr);
  align-items: center;
  gap: clamp(28px, 5vw, 86px);
  padding: clamp(34px, 5vw, 78px);
}

.brand-panel {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: clamp(36px, 8vh, 84px);
}

.menu-hero .hero-logo {
  margin: 0 !important;
  width: min(36vw, 560px) !important;
  max-width: min(36vw, 560px) !important;
}

.hero-copy {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  padding: 0;
  isolation: isolate;
}

.thai-title {
  color: #0B1220 !important;
  font-size: clamp(54px, 4.6vw, 82px);
  font-weight: 900;
  line-height: 1.05;
  opacity: 1 !important;
  white-space: nowrap;
  -webkit-text-stroke: 0.6px #0B1220;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);
}

.english-title {
  color: #0B1220 !important;
  font-size: clamp(28px, 2.7vw, 48px);
  font-weight: 900;
  line-height: 1.25;
  margin-top: 12px;
  opacity: 1 !important;
  -webkit-text-stroke: 0.35px #0B1220;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.title-line {
  width: min(420px, 32vw);
  margin: 24px auto 0;
  border-top-width: 8px !important;
  border-color: #0B1220 !important;
  opacity: 1;
}

.menu-hero .action-panel {
  width: min(820px, 100%) !important;
  min-height: 420px !important;
  margin: 0 auto !important;
  justify-self: center;
}

.action-content {
  width: 100%;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(28px, 5vh, 48px);
  text-align: center;
  padding: clamp(18px, 2.5vw, 40px);
}

.action-content > div {
  width: 100%;
}

.action-eyebrow {
  color: #344054;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 12px;
}

.welcome-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.welcome-en {
  color: #111827;
  font-size: clamp(56px, 5.4vw, 92px);
  font-weight: 900;
  line-height: 1;
}

.welcome-th {
  color: #344054;
  font-size: clamp(34px, 3.2vw, 56px);
  font-weight: 900;
  line-height: 1.1;
}

.primary-action {
  position: relative;
  width: min(500px, 100%) !important;
  margin-left: auto;
  margin-right: auto;
  min-height: 118px;
  padding-left: 34px;
  padding-right: 34px;
  overflow: hidden;
  clip-path: none !important;
  border-radius: 999px !important;
  background:
    radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.34) 0%, rgba(255, 255, 255, 0.12) 32%, transparent 62%),
    linear-gradient(180deg, #536176 0%, #344054 48%, #1F2937 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.34);
  box-shadow:
    0 26px 42px rgba(16, 24, 40, 0.28),
    0 10px 0 #111827,
    inset 0 3px 0 rgba(255, 255, 255, 0.24),
    inset 0 -5px 10px rgba(0, 0, 0, 0.22);
  filter: drop-shadow(0 16px 18px rgba(16, 24, 40, 0.18));
}

.primary-action::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 34%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0) 28%);
  pointer-events: none;
}

.primary-action::after {
  content: "";
  position: absolute;
  top: 0;
  right: 20px;
  width: 42px;
  height: 100%;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  transform: skewX(-16deg);
  pointer-events: none;
}

.primary-action:hover {
  transform: translateY(-4px);
  box-shadow:
    0 28px 44px rgba(16, 24, 40, 0.3),
    0 9px 0 #182230,
    inset 0 2px 0 rgba(255, 255, 255, 0.32),
    inset 0 -2px 0 rgba(0, 0, 0, 0.2);
}

.primary-action:active {
  transform: translateY(5px);
  box-shadow:
    0 12px 24px rgba(16, 24, 40, 0.22),
    0 3px 0 #182230,
    inset 0 2px 8px rgba(0, 0, 0, 0.24);
}

.primary-action span {
  position: relative;
  z-index: 1;
  font-size: clamp(34px, 2.8vw, 46px);
  font-weight: 900;
  letter-spacing: 0;
  text-shadow: 0 2px 3px rgba(0, 0, 0, 0.22);
}

.primary-action small {
  position: relative;
  z-index: 1;
  font-size: clamp(17px, 1.35vw, 24px);
  font-weight: 900;
  letter-spacing: 0;
  opacity: 0.92;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }

  .menu-hero {
    grid-template-columns: 1fr;
    align-content: center;
  }

  .brand-panel {
    align-items: center;
    text-align: center;
  }

  .hero-copy {
    align-items: center;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.box {

  color: white;
  /* สีตัวอักษร */
  padding: 15px;
  /* ระยะห่างภายใน */
  text-align: center;
  /* จัดข้อความกึ่งกลาง */
  width: 350px;
  /* ความกว้าง */

  /* --- หัวใจสำคัญคือบรรทัดนี้ --- */
  clip-path: polygon(25px 0,
      /* จุดที่ 1: เริ่มจากมุมบน แต่ขยับขวามา 25px */
      100% 0,
      /* จุดที่ 2: ไปที่มุมบนขวา */
      100% calc(100% - 25px),
      /* จุดที่ 3: ลงมาที่ขอบล่าง แต่เว้นระยะจากมุม 25px */
      calc(100% - 25px) 100%,
      /* จุดที่ 4: ไปที่มุมล่าง แต่ขยับซ้ายมา 25px */
      0 100%,
      /* จุดที่ 5: ไปที่มุมล่างซ้าย */
      0 25px
      /* จุดที่ 6: กลับขึ้นไปที่ขอบบน แต่เว้นระยะจากมุม 25px */
    );
}
</style>
